import axios from "axios"
import Qs from "qs"
import router from '../router'

import { Loading,Message } from 'element-ui';
import alertDom from './alertMessage.js' //防止多次请求弹窗



// 加载函数Loading S
let needLoadingRequestCount = 0

function showLoading() {

    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

function hideLoading() {
    setTimeout(tryCloseLoading, 200)
}

function tryCloseLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}

function startLoading() {

    Loading.service({
        lock: false,
        text: '加载中……',
        background: 'rgba(0, 0, 0, .5)',
    });

}

function endLoading() {
    Loading.service({
        lock: false,
        text: '加载中……',
        background: 'rgba(0, 0, 0, .5)',
    }).close()

}




const BASE_URL = process.env.API_ROOT

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 20000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

axios.defaults.headers.get['Content-Type'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'

//请求拦截
axios.interceptors.request.use(
    config => {
        /* 添加loading S */

        if (config.config && config.config.showLoading === true) { // 全局loading
            showLoading()
        }
        let url = config.url
        if (url.indexOf("/backend/tokens") > -1) { //如果是登录传空
            config.headers.Authorization = "";
            config.headers.Uid = "";
        } else { //其他
            let token = sessionStorage.getItem('token') || ""
            config.headers.Authorization = 'Bearer '+token;
        }
        return config
    }, error => {
        /* 关闭loading S */
        hideLoading()
        return Promise.error(error)
    })

// 对象实例
const alertbox = new alertDom()
//响应拦截
axios.interceptors.response.use(
    response => {
        /* 关闭loading S */
        hideLoading()
        //如果返回的状态码为200,说明接口请求成功，可以正常拿到数据
        if (response.status == 200) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        /* 关闭loading S */
        hideLoading()
        console.log('wsm 为什么 这里 会报错 ', error)
        if(error.response.status==401){
          alertbox.warning({
              message: '已过有效期，请重新登录',
              type: 'warning'
          })
          return redirectLogin()
        }
        if(error.response.status==429){
          alertbox.warning({
              message: '操作过于频繁，请稍后再试',
              type: 'warning'
          })
        }
        return Promise.reject(error.response);

    }
)

function redirectLogin(){
  router.replace('/')
  sessionStorage.setItem('subIndex',0)
  sessionStorage.setItem('subId',1)
}




function get(url, params, config = { showLoading: true }) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            params: params,
            config
        }).then(res => {
            resolve(res.data)

        }).catch(err => {
            reject(err.data)
        })
    })
}

function post(url, params, config = { showLoading: true }) {
    return new Promise((resolve, reject) => {
        // params = Qs.stringify(params)
        params=params
        axios.post(url, params, config).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

function put(url, params, config = { showLoading: true }) {
    return new Promise((resolve, reject) => {
        // params = Qs.stringify(params)
        params=params
        axios.put(url, params, config).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}


//非json格式的post请求
function postrest(url, params) {
    return new Promise((resolve, reject) => {

        params = Qs.stringify(params)
        axios.post(url, params).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}


export default {
    get,
    post,
    put,
    postrest
}



// WEBPACK FOOTER //
// ./src/utils/request.js